let r = (Math.random() + 1).toString(36).substring(7);
window.countryListPop =[
     {
        "code": "fr",
        "flag": "https://flagcdn.com/w40/fr.png",
        "name": "France",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "de",
        "flag": "https://flagcdn.com/w40/de.png",
        "name": "Germany",
        "shop_online": true,
        "languages": [{ "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?ecomm="+r }, { "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "it",
        "flag": "https://flagcdn.com/w40/it.png",
        "name": "Italy",
        "shop_online": true,
        "languages": [{ "name": "Italian", "code": "IT", "site": "https://saphir.paris/it/?ecomm="+r }, { "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "es",
        "flag": "https://flagcdn.com/w40/es.png",
        "name": "Spain",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "gb",
        "flag": "https://flagcdn.com/w40/gb.png",
        "name": "United Kingdom",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://uk.saphir.paris/" }], 
plane: false,
    },
    {
        "code": "au",
        "flag": "https://flagcdn.com/w40/au.png",
        "name": "Australia",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://au.saphir.paris/" }],
    },
    {
        "code": "af",
        "flag": "https://flagcdn.com/w40/af.png",
        "name": "Afghanistan",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "al",
        "flag": "https://flagcdn.com/w40/al.png",
        "name": "Albania",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "dz",
        "flag": "https://flagcdn.com/w40/dz.png",
        "name": "Algeria",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "ad",
        "flag": "https://flagcdn.com/w40/ad.png",
        "name": "Andorra",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "ao",
        "flag": "https://flagcdn.com/w40/ao.png",
        "name": "Angola",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "ag",
        "flag": "https://flagcdn.com/w40/ag.png",
        "name": "Antigua and Barbuda",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "ar",
        "flag": "https://flagcdn.com/w40/ar.png",
        "name": "Argentina",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "am",
        "flag": "https://flagcdn.com/w40/am.png",
        "name": "Armenia",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "at",
        "flag": "https://flagcdn.com/w40/at.png",
        "name": "Austria",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r },{ "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "az",
        "flag": "https://flagcdn.com/w40/az.png",
        "name": "Azerbaijan",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "bs",
        "flag": "https://flagcdn.com/w40/bs.png",
        "name": "Bahamas",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "bh",
        "flag": "https://flagcdn.com/w40/bh.png",
        "name": "Bahrain",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "bd",
        "flag": "https://flagcdn.com/w40/bd.png",
        "name": "Bangladesh",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "bb",
        "flag": "https://flagcdn.com/w40/bb.png",
        "name": "Barbados",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "by",
        "flag": "https://flagcdn.com/w40/by.png",
        "name": "Belarus",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "be",
        "flag": "https://flagcdn.com/w40/be.png",
        "name": "Belgium",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "bz",
        "flag": "https://flagcdn.com/w40/bz.png",
        "name": "Belize",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "bj",
        "flag": "https://flagcdn.com/w40/bj.png",
        "name": "Benin",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "bt",
        "flag": "https://flagcdn.com/w40/bt.png",
        "name": "Bhutan",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "bo",
        "flag": "https://flagcdn.com/w40/bo.png",
        "name": "Bolivia",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "ba",
        "flag": "https://flagcdn.com/w40/ba.png",
        "name": "Bosnia and Herzegovina",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "bw",
        "flag": "https://flagcdn.com/w40/bw.png",
        "name": "Botswana",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "br",
        "flag": "https://flagcdn.com/w40/br.png",
        "name": "Brazil",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
	},
    {
        "code": "bn",
        "flag": "https://flagcdn.com/w40/bn.png",
        "name": "Brunei",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
     },
    {
        "code": "bg",
        "flag": "https://flagcdn.com/w40/bg.png",
        "name": "Bulgaria",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "bf",
        "flag": "https://flagcdn.com/w40/bf.png",
        "name": "Burkina Faso",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,  
    },
    {
        "code": "bi",
        "flag": "https://flagcdn.com/w40/bi.png",
        "name": "Burundi",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "cv",
        "flag": "https://flagcdn.com/w40/cv.png",
        "name": "Cabo Verde",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "kh",
        "flag": "https://flagcdn.com/w40/kh.png",
        "name": "Cambodia",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true, 
    },
    {
        "code": "cm",
        "flag": "https://flagcdn.com/w40/cm.png",
        "name": "Cameroon",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "ca",
        "flag": "https://flagcdn.com/w40/ca.png",
        "name": "Canada",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "cf",
        "flag": "https://flagcdn.com/w40/cf.png",
        "name": "Central African Republic",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "td",
        "flag": "https://flagcdn.com/w40/td.png",
        "name": "Chad",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "cl",
        "flag": "https://flagcdn.com/w40/cl.png",
        "name": "Chile",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "cn",
        "flag": "https://flagcdn.com/w40/cn.png",
        "name": "China",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "co",
        "flag": "https://flagcdn.com/w40/co.png",
        "name": "Colombia",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "km",
        "flag": "https://flagcdn.com/w40/km.png",
        "name": "Comoros",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "cg",
        "flag": "https://flagcdn.com/w40/cg.png",
        "name": "Congo",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "cd",
        "flag": "https://flagcdn.com/w40/cd.png",
        "name": "Democratic Republic of the Congo",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "fr",
        "flag": "https://flagcdn.com/w40/fr.png",
        "name": "D.O.M. France",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "cr",
        "flag": "https://flagcdn.com/w40/cr.png",
        "name": "Costa Rica",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "hr",
        "flag": "https://flagcdn.com/w40/hr.png",
        "name": "Croatia",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "cu",
        "flag": "https://flagcdn.com/w40/cu.png",
        "name": "Cuba",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "cy",
        "flag": "https://flagcdn.com/w40/cy.png",
        "name": "Cyprus",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "cz",
        "flag": "https://flagcdn.com/w40/cz.png",
        "name": "Czech Republic",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "dk",
        "flag": "https://flagcdn.com/w40/dk.png",
        "name": "Denmark",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "dj",
        "flag": "https://flagcdn.com/w40/dj.png",
        "name": "Djibouti",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "dm",
        "flag": "https://flagcdn.com/w40/dm.png",
        "name": "Dominica",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "do",
        "flag": "https://flagcdn.com/w40/do.png",
        "name": "Dominican Republic",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "cd",
        "flag": "https://flagcdn.com/w40/cd.png",
        "name": "Democratic Republic of the Congo",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "ec",
        "flag": "https://flagcdn.com/w40/ec.png",
        "name": "Ecuador",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "eg",
        "flag": "https://flagcdn.com/w40/eg.png",
        "name": "Egypt",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "sv",
        "flag": "https://flagcdn.com/w40/sv.png",
        "name": "El Salvador",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "gq",
        "flag": "https://flagcdn.com/w40/gq.png",
        "name": "Equatorial Guinea",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "er",
        "flag": "https://flagcdn.com/w40/er.png",
        "name": "Eritrea",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "ee",
        "flag": "https://flagcdn.com/w40/ee.png",
        "name": "Estonia",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "sz",
        "flag": "https://flagcdn.com/w40/sz.png",
        "name": "Eswatini",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "et",
        "flag": "https://flagcdn.com/w40/et.png",
        "name": "Ethiopia",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "fj",
        "flag": "https://flagcdn.com/w40/fj.png",
        "name": "Fiji",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "fi",
        "flag": "https://flagcdn.com/w40/fi.png",
        "name": "Finland",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "fr",
        "flag": "https://flagcdn.com/w40/fr.png",
        "name": "France Corsica, Coastal Islands",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "fr",
        "flag": "https://flagcdn.com/w40/fr.png",
        "name": "France Army Sector",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "fo",
        "flag": "https://flagcdn.com/w40/fo.png",
        "name": "Faroe Islands",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "ga",
        "flag": "https://flagcdn.com/w40/ga.png",
        "name": "Gabon",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "gm",
        "flag": "https://flagcdn.com/w40/gm.png",
        "name": "Gambia",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "ge",
        "flag": "https://flagcdn.com/w40/ge.png",
        "name": "Georgia",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "gh",
        "flag": "https://flagcdn.com/w40/gh.png",
        "name": "Ghana",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "gi",
        "flag": "https://flagcdn.com/w40/gi.png",
        "name": "Gibraltar",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "gr",
        "flag": "https://flagcdn.com/w40/gr.png",
        "name": "Greece",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "gd",
        "flag": "https://flagcdn.com/w40/gd.png",
        "name": "Grenada",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "gl",
        "flag": "https://flagcdn.com/w40/gl.png",
        "name": "Greenland",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "gt",
        "flag": "https://flagcdn.com/w40/gt.png",
        "name": "Guatemala",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "gn",
        "flag": "https://flagcdn.com/w40/gn.png",
        "name": "Guinea",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "gy",
        "flag": "https://flagcdn.com/w40/gy.png",
        "name": "Guyana",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "ht",
        "flag": "https://flagcdn.com/w40/ht.png",
        "name": "Haiti",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "HK",
        "flag": "https://flagcdn.com/w40/HK.png",
        "name": "Hong Kong",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "hu",
        "flag": "https://flagcdn.com/w40/hu.png",
        "name": "Hungary",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "in",
        "flag": "https://flagcdn.com/w40/in.png",
        "name": "India",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "id",
        "flag": "https://flagcdn.com/w40/id.png",
        "name": "Indonesia",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "iq",
        "flag": "https://flagcdn.com/w40/iq.png",
        "name": "Iraq",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
	},
    {
        "code": "ie",
        "flag": "https://flagcdn.com/w40/ie.png",
        "name": "Ireland",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "ci",
        "flag": "https://flagcdn.com/w40/ci.png",
        "name": "Ivory Coast",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "is",
        "flag": "https://flagcdn.com/w40/is.png",
        "name": "Iceland",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "il",
        "flag": "https://flagcdn.com/w40/il.png",
        "name": "Israel",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "jo",
        "flag": "https://flagcdn.com/w40/jo.png",
        "name": "Jordan",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "jp",
        "flag": "https://flagcdn.com/w40/jp.png",
        "name": "Japan",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "kz",
        "flag": "https://flagcdn.com/w40/kz.png",
        "name": "Kazakhstan",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "ke",
        "flag": "https://flagcdn.com/w40/ke.png",
        "name": "Kenya",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "kg",
        "flag": "https://flagcdn.com/w40/kg.png",
        "name": "Kyrgyzstan",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,    
   },
    {
        "code": "kw",
        "flag": "https://flagcdn.com/w40/kw.png",
        "name": "Kuwait",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
     },
    {
        "code": "la",
        "flag": "https://flagcdn.com/w40/la.png",
        "name": "Laos",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "lv",
        "flag": "https://flagcdn.com/w40/lv.png",
        "name": "Latvia",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false, 
                      
    },
    {
        "code": "lb",
        "flag": "https://flagcdn.com/w40/lb.png",
        "name": "Lebanon",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "li",
        "flag": "https://flagcdn.com/w40/li.png",
        "name": "Liechtenstein",
        "shop_online": true,
       "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "lt",
        "flag": "https://flagcdn.com/w40/lt.png",
        "name": "Lithuania",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,  
    },
    {
        "code": "lu",
        "flag": "https://flagcdn.com/w40/lu.png",
        "name": "Luxembourg",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "mo",
        "flag": "https://flagcdn.com/w40/mo.png",
        "name": "Macau",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true, 
    },
    {
        "code": "mk",
        "flag": "https://flagcdn.com/w40/mk.png",
        "name": "Macedonia",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "mg",
        "flag": "https://flagcdn.com/w40/mg.png",
        "name": "Madagascar",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "my",
        "flag": "https://flagcdn.com/w40/my.png",
        "name": "Malaysia",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true, 
    },
    {
        "code": "ml",
        "flag": "https://flagcdn.com/w40/ml.png",
        "name": "Mali",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true, 
    },
    {
        "code": "mt",
        "flag": "https://flagcdn.com/w40/mt.png",
        "name": "Malta",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "ma",
        "flag": "https://flagcdn.com/w40/ma.png",
        "name": "Morocco",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,   
    },
    {
        "code": "yt",
        "flag": "https://flagcdn.com/w40/yt.png",
        "name": "Mayotte",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "mu",
        "flag": "https://flagcdn.com/w40/mu.png",
        "name": "Mauritius",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "md",
        "flag": "https://flagcdn.com/w40/md.png",
        "name": "Moldova",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,   
    },
    {
        "code": "mc",
        "flag": "https://flagcdn.com/w40/mc.png",
        "name": "Monaco",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,  
    },
    {
        "code": "me",
        "flag": "https://flagcdn.com/w40/me.png",
        "name": "Montenegro",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,      
    },
    {
        "code": "mx",
        "flag": "https://flagcdn.com/w40/mx.png",
        "name": "Mexico",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "nl",
        "flag": "https://flagcdn.com/w40/nl.png",
        "name": "Netherlands",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: false,
    },
    {
        "code": "nz",
        "flag": "https://flagcdn.com/w40/nz.png",
        "name": "New Zealand",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "ne",
        "flag": "https://flagcdn.com/w40/ne.png",
        "name": "Niger",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "no",
        "flag": "https://flagcdn.com/w40/no.png",
        "name": "Norway",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "nz",
        "flag": "https://flagcdn.com/w40/nz.png",
        "name": "New Zealand",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,  
    },
    {
        "code": "gb-nir",
        "flag": "https://flagcdn.com/w40/gb-nir.png",
        "name": "Northern Ireland",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,   
    },
    {
        "code": "ng",
        "flag": "https://flagcdn.com/w40/ng.png",
        "name": "Nigeria",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "om",
        "flag": "https://flagcdn.com/w40/om.png",
        "name": "Oman",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "pk",
        "flag": "https://flagcdn.com/w40/pk.png",
        "name": "Pakistan",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,   
     },
    {
        "code": "pa",
        "flag": "https://flagcdn.com/w40/pa.png",
        "name": "Panama",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,  
    },
    {
        "code": "pe",
        "flag": "https://flagcdn.com/w40/pe.png",
        "name": "Peru",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,  
    },
    {
        "code": "ph",
        "flag": "https://flagcdn.com/w40/ph.png",
        "name": "Philippines",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "pl",
        "flag": "https://flagcdn.com/w40/pl.png",
        "name": "Poland",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "pr",
        "flag": "https://flagcdn.com/w40/pr.png",
        "name": "Puerto Rico",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "pt",
        "flag": "https://flagcdn.com/w40/pt.png",
        "name": "Portugal",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "qa",
        "flag": "https://flagcdn.com/w40/qa.png",
        "name": "Qatar",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "ro",
        "flag": "https://flagcdn.com/w40/ro.png",
        "name": "Romania",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "ru",
        "flag": "https://flagcdn.com/w40/ru.png",
        "name": "Russia",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "mf",
        "flag": "https://flagcdn.com/w40/mf.png",
        "name": "Saint Martin",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "sn",
        "flag": "https://flagcdn.com/w40/sn.png",
        "name": "Senegal",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "rs",
        "flag": "https://flagcdn.com/w40/rs.png",
        "name": "Serbia",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "sg",
        "flag": "https://flagcdn.com/w40/sg.png",
        "name": "Singapore",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "sk",
        "flag": "https://flagcdn.com/w40/sk.png",
        "name": "Slovakia",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "si",
        "flag": "https://flagcdn.com/w40/si.png",
        "name": "Slovenia",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "ch",
        "flag": "https://flagcdn.com/w40/ch.png",
        "name": "Switzerland",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: false,
    },
    {
        "code": "sy",
        "flag": "https://flagcdn.com/w40/sy.png",
        "name": "Syria",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "za",
        "flag": "https://flagcdn.com/w40/za.png",
        "name": "South Africa",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "sau",
        "flag": "https://flagcdn.com/w40/za.png",
        "name": "Saudi Arabia",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "kr",
        "flag": "https://flagcdn.com/w40/kr.png",
        "name": "South Korea",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "sb",
        "flag": "https://flagcdn.com/w40/sb.png",
        "name": "Solomon Islands",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "se",
        "flag": "https://flagcdn.com/w40/se.png",
        "name": "Sweden",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: false,
    },
    {
        "code": "ch",
        "flag": "https://flagcdn.com/w40/ch.png",
        "name": "Switzerland",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: false,
    },
    {
        "code": "th",
        "flag": "https://flagcdn.com/w40/th.png",
        "name": "Thailand",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "pf",
        "flag": "https://flagcdn.com/w40/pf.png",
        "name": "T.O.M. France - French Polynesia",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "nc",
        "flag": "https://flagcdn.com/w40/nc.png",
        "name": "T.O.M. France - New Caledonia",
        "shop_online": true,
         "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "wf",
        "flag": "https://flagcdn.com/w40/wf.png",
        "name": "T.O.M. France - Wallis and Futuna",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "tw",
        "flag": "https://flagcdn.com/w40/tw.png",
        "name": "Taiwan",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
     },
    {
        "code": "tg",
        "flag": "https://flagcdn.com/w40/tg.png",
        "name": "Togo",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,   
    },
    {
        "code": "tn",
        "flag": "https://flagcdn.com/w40/tn.png",
        "name": "Tunisia",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "nl",
        "flag": "https://flagcdn.com/w40/nl.png",
        "name": "Netherlands",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "tr",
        "flag": "https://flagcdn.com/w40/tr.png",
        "name": "Turkey",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,  
    },
    {
        "code": "ua",
        "flag": "https://flagcdn.com/w40/ua.png",
        "name": "Ukraine",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "uz",
        "flag": "https://flagcdn.com/w40/uz.png",
        "name": "Uzbekistan",
        "shop_online": true,
       "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,  
    },
    {
        "code": "ae",
        "flag": "https://flagcdn.com/w40/ae.png",
        "name": "United Arab Emirates",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "us",
        "flag": "https://flagcdn.com/w40/us.png",
        "name": "United States",
        "shop_online": false,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?noecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?noecomm="+r }, { "name": "Deutsche", "code": "DE", "site": "https://saphir.paris/de/?noecomm="+r }], 
plane: true,
    },
    {
        "code": "vn",
        "flag": "https://flagcdn.com/w40/vn.png",
        "name": "Vietnam",
        "shop_online": true,
	    "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "vu",
        "flag": "https://flagcdn.com/w40/vu.png",
        "name": "Vanuatu",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "va",
        "flag": "https://flagcdn.com/w40/va.png",
        "name": "Vatican City",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "zm",
        "flag": "https://flagcdn.com/w40/zm.png",
        "name": "Zambia",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
    {
        "code": "ax",
        "flag": "https://flagcdn.com/w40/ax.png",
        "name": "Åland Islands",
        "shop_online": true,
        "languages": [{ "name": "English", "code": "EN", "site": "https://saphir.paris/en/?ecomm="+r }, { "name": "French", "code": "FR", "site": "https://saphir.paris/?ecomm="+r }], 
plane: true,
    },
];

// const select = document.getElementById("country-select");

// const flagImg = document.getElementById("flag-img");

// countries.forEach(country => {
//     const option = document.createElement("option");
//     option.value = country.code;
//     option.textContent = country.name;
//     option.setAttribute("data-flag", country.flag);
//     select.appendChild(option);
// });

// function updateFlag(select) {
//     const selectedOption = select.options[select.selectedIndex];
//     if (selectedOption.value) {
//         flagImg.src = selectedOption.getAttribute("data-flag");
//         flagImg.style.display = "inline";
//     } else {
//         flagImg.style.display = "none";
//     }
// }